var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIClockWhite = function SvgIClockWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2635 6.73648C34.9193 2.39245 29.1435 0 23 0C16.8565 0 11.0807 2.39245 6.73648 6.73648C2.39245 11.0807 0 16.8565 0 23C0 29.1435 2.39245 34.9193 6.73648 39.2635C11.0807 43.6075 16.8565 46 23 46C27.2058 46 31.321 44.8539 34.9009 42.6854C35.7496 42.1713 36.021 41.0663 35.5068 40.2176C34.9925 39.3686 33.8876 39.0974 33.0389 39.6116C30.0207 41.4399 26.5492 42.4062 23 42.4062C12.2993 42.4062 3.59375 33.7007 3.59375 23C3.59375 12.2993 12.2993 3.59375 23 3.59375C33.7007 3.59375 42.4062 12.2993 42.4062 23C42.4062 26.8264 41.2684 30.5508 39.1156 33.7709C38.5641 34.5959 38.7857 35.7118 39.6107 36.2634C40.4358 36.815 41.5517 36.5932 42.1031 35.7682C44.6525 31.9551 46 27.5399 46 23C46 16.8565 43.6075 11.0807 39.2635 6.73648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 23H21.875C20.8394 23 20 24.1193 20 25.5C20 26.8807 20.8394 28 21.875 28H33.125C34.1606 28 35 26.8807 35 25.5C35 24.1193 34.1606 23 33.125 23Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.375L25 8.625C25 7.17521 23.8807 6 22.5 6C21.1193 6 20 7.17521 20 8.625L20 24.375C20 25.8248 21.1192 27 22.5 27C23.8807 27 25 25.8248 25 24.375Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIClockWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-clock-white.5d62f005.svg";
export { ForwardRef as ReactComponent };